import type { ColumnsType } from 'antd/lib/table'
import { CustomHeaderText } from 'src/components'

const parcelPreviewListColumns: ColumnsType<any> = [
  {
    title: () => <CustomHeaderText text={'admin.MassiveCalculate.tables.Plane.From'} />,
    dataIndex: 'from',
    render: (_, record) => {
      return (
        <div style={{ marginTop: '10px' }}>
          <span style={{ textAlign: 'center' }}>
            {record.from}
          </span>
        </div>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'admin.MassiveCalculate.tables.Plane.To'} />,
    dataIndex: 'to',
    render: (_, record) => {
      return (
        <div style={{ marginTop: '10px' }}>
          <span style={{ textAlign: 'center' }}>
            {record.to}
          </span>
        </div>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'admin.MassiveCalculate.tables.Parcel.Weigth'} />,
    dataIndex: 'weigth',
    render: (_, record) => {
      return (
        <div style={{ marginTop: '10px' }}>
          <span style={{ textAlign: 'center' }}>
            {record.weigth}
          </span>
        </div>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'admin.MassiveCalculate.tables.Parcel.FleetType'} />,
    dataIndex: 'fleetType',
    render: (_, record) => {
      return (
        <div style={{ marginTop: '10px' }}>
          <span style={{ textAlign: 'center' }}>
            {record.fleetType}
          </span>
        </div>
      )
    },
  },
]

export default parcelPreviewListColumns
